var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import striptags from 'striptags';
import { classNames, useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from 'components/Button';
import { ButtonDropdown } from 'components/ButtonDropdown';
import { FormInput } from 'components/form/FormInput';
import { Icon } from 'components/Icon';
import { Money } from 'components/Money';
import { DealItemDiscountedPrice } from './DealItemDiscountedPrice';
import { DateTime } from 'components/DateTime';
import { Text } from 'components/Text';
import { Image } from 'components/Image';
import { Case } from 'components/util/Case';
import { React } from 'libs/react';
import { getMarkup, getMargin, getPriceFromItem, getPricePerUnitFromMarkup, getPricePerUnitFromMargin } from 'helpers/Pricing';
import { useUser } from 'components/user/UserProvider';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { getTimeSlotDate } from 'helpers/timeSlot';
import { DealItemEditModal } from '../../modal/DealItemEditModal';
import { DealAvailabilityModal } from '../../../modal/DealAvailabilityModal';
import { useModal } from 'components/modal/ModalStack';
import { formatFieldValue } from 'helpers/Field';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import { useDealDetailContext } from 'modules/deal/DealDetails';
import { QuoteMedia } from 'modules/public/quote/components/QuoteMedia';
import i18n from 'components/translation/i18n';
import { useBreakpoint } from 'components/util/BreakpointProvider';
import { getUnitOfMeasurementLabel } from 'modules/catalog/saleItem/forms/SaleItemForm';
import { showBundledQuoteConfigurationQuantity } from 'helpers/quoteBundled';
import { getConfigurationEffectiveQuantity, getConfigurationQuantitySuffix } from 'helpers/DealQuantity';
import '../DealItemPanelGroupContent.scss';
import { useAccount } from 'components/account/AccountProvider';
export function ProposedOptionsListItem(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
    const { item, data, isDeal, editable, hideSKU, discountRep, pricingDisplay, pricingParametersDisplay, quantityType, itemsGrouped } = props;
    const breakpoint = useBreakpoint();
    const { includeOptionQuote } = useQuoteContext();
    const quoteContext = useQuoteContext();
    const dealDetailContext = useDealDetailContext();
    const _15 = useDealConfiguratorContext(), { includeOption, onOptionDelete, onItemPriceChange, deal, updateOptionFieldValues, onOptionQuantityChange, updateMarkupPerItem, onMoveItemConfiguration, hideDealItemConfiguration, configurationFields, hasDealItemConfigurationTime: hasDealItemConfigurationTimeCfg } = _15, dealConfiguratorContext = __rest(_15, ["includeOption", "onOptionDelete", "onItemPriceChange", "deal", "updateOptionFieldValues", "onOptionQuantityChange", "updateMarkupPerItem", "onMoveItemConfiguration", "hideDealItemConfiguration", "configurationFields", "hasDealItemConfigurationTime"]);
    const hasDealItemConfigurationTime = hasDealItemConfigurationTimeCfg ||
        quoteContext.hasDealItemConfigurationTime;
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    const [costPrice, setCostPrice] = useState(getPriceFromItem(item.item, (_a = item.variant) !== null && _a !== void 0 ? _a : null, (_b = data.item) !== null && _b !== void 0 ? _b : null, 'option', deal === null || deal === void 0 ? void 0 : deal.currency));
    const [amount, setAmount] = useState((_c = data.price) !== null && _c !== void 0 ? _c : 0);
    const dealerDiscount = (discountRep * costPrice) / 100;
    const dealerPrice = costPrice - dealerDiscount;
    const [markup, setMarkup] = useState(getMarkup(dealerPrice, amount).toFixed(0).toString());
    const [margin, setMargin] = useState(getMargin(dealerPrice, amount).toFixed(0).toString());
    const [discount, setDiscount] = useState(dealerPrice !== 0
        ? Number((((dealerPrice - amount) / dealerPrice) * 100).toFixed(2))
        : 0);
    const [pricePerUnit, setPricePerUnit] = useState(Number.isFinite(amount) ? amount.toFixed(2).toString() : '0');
    const [userInputMarkup, setUserInputMarkup] = useState(false);
    const [userInputMargin, setUserInputMargin] = useState(false);
    const [userInputDiscount, setUserInputDiscount] = useState(false);
    const [userInputPricePerUnit, setUserInputPricePerUnit] = useState(true);
    const [openModalEditFields, setOpenModalEditFields] = useState(false);
    const [openModalAvailability, setOpenModalAvailability] = useState(false);
    const [quantity, setQuantity] = useState(data.quantity);
    const markupRef = useRef(null);
    const marginRef = useRef(null);
    const discountRef = useRef(null);
    const pricePerUnitRef = useRef(null);
    const user = useUser();
    const modal = useModal();
    const quantityTypeValue = quantityType && quantityType != ''
        ? quantityType
        : dealConfiguratorContext.quantityType != ''
            ? dealConfiguratorContext.quantityType
            : quoteContext.quantityType;
    const quoteDealItemConfigurationFields = quoteContext.dealItemConfigurationFields.length > 0
        ? quoteContext.dealItemConfigurationFields
        : dealDetailContext.dealItemConfigurationFields.length > 0
            ? dealDetailContext.dealItemConfigurationFields
            : dealConfiguratorContext.dealItemConfigurationFields;
    const pricingParameters = dealConfiguratorContext
        ? dealConfiguratorContext.pricingParameters
        : quoteContext.pricingParameters;
    const dealValue = deal !== null && deal !== void 0 ? deal : quoteContext.deal;
    const showLineDiscount = !editable && !!(dealValue === null || dealValue === void 0 ? void 0 : dealValue.showDiscount) && pricingDisplay !== 'BUNDLED';
    const effectiveQuantity = getConfigurationEffectiveQuantity(data.quantity, (_d = data.item) === null || _d === void 0 ? void 0 : _d.quantityCalculation, dealValue);
    const quantitySuffix = getConfigurationQuantitySuffix((_e = data.item) === null || _e === void 0 ? void 0 : _e.quantityCalculation, dealValue, getUnitOfMeasurementLabel((_f = data.item) === null || _f === void 0 ? void 0 : _f.unitOfMeasurement));
    const showConfigurationQuantity = showBundledQuoteConfigurationQuantity(data, pricingDisplay, editable);
    const itemSorting = (_j = JSON.parse((_h = (_g = configurationFields.find((conf) => conf.fieldKey === 'ITEM_SORTING')) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : '{}')) === null || _j === void 0 ? void 0 : _j.value;
    useEffect(() => {
        setPricePerUnit(Number.isFinite(dealerPrice) ? dealerPrice.toFixed(2) : '0');
    }, [amount]);
    useEffect(() => {
        var _a;
        setQuantity(data.quantity);
        const newPrice = (_a = data.price) !== null && _a !== void 0 ? _a : 0;
        setPricePerUnit(Number.isFinite(newPrice) ? newPrice.toFixed(2).toString() : '0');
        setMarkup(getMarkup(dealerPrice, newPrice).toFixed(0).toString());
        setMargin(getMargin(dealerPrice, newPrice).toFixed(0).toString());
        setDiscount(dealerPrice !== 0
            ? Number((((dealerPrice - newPrice) / dealerPrice) * 100).toFixed(2))
            : 0);
    }, [data, dealerPrice]);
    useEffect(() => {
        var _a, _b;
        setCostPrice(getPriceFromItem(item.item, (_a = item.variant) !== null && _a !== void 0 ? _a : null, (_b = data.item) !== null && _b !== void 0 ? _b : null, 'option', deal === null || deal === void 0 ? void 0 : deal.currency));
    }, [deal === null || deal === void 0 ? void 0 : deal.currency]);
    /**
     * @component onPressAddOptionsToItem
     * @since 1.0.0
     * @hidden
     */
    const onPressAddOptionToItem = () => {
        includeOption(item, data, false);
    };
    /**
     * @component onPressDeleteProposedOption
     * @since 1.0.0
     * @hidden
     */
    const onPressDeleteProposedOption = () => {
        onOptionDelete(item, data);
    };
    /**
     * @component onPressAddOption
     * @since 1.0.0
     * @hidden
     */
    const onPressAddOption = () => {
        includeOptionQuote(item, data, false);
    };
    /**
     * @function onMarkupChange
     * @since 1.0.0
     * @hidden
     */
    const onMarkupChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMarkup(dealerPrice, Number(value));
        setMarkup(value);
        updateMarkupPerItem(data.id, Number(value), false);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onMarginChange
     * @since 1.0.0
     * @hidden
     */
    const onMarginChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMargin(dealerPrice, Number(value));
        setMargin(value);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onDiscountChange
     * @since 1.0.0
     * @hidden
     */
    const onDiscountChange = (value) => {
        const pricePerUnit = dealerPrice - dealerPrice * (Number(value) / 100);
        setDiscount(Number(value));
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onOptionProposedPricePerUnitChange
     * @since 1.0.0
     * @hidden
     */
    const onOptionProposedPricePerUnitChange = (value) => {
        const markup = getMarkup(dealerPrice, Number(value)).toFixed(0);
        const margin = getMargin(dealerPrice, Number(value)).toFixed(0);
        const discount = ((dealerPrice - Number(value)) / dealerPrice) * 100;
        setPricePerUnit(value);
        setMarkup(markup);
        setMargin(margin);
        setDiscount(Number(discount.toFixed(2)));
        updateMarkupPerItem(data.id, Number(markup), false);
    };
    /**
     * @function onPriceChange
     * @since 1.0.0
     * @hidden
     */
    const onPriceChange = (value) => {
        var _a;
        if (item.options && (data === null || data === void 0 ? void 0 : data.id)) {
            const tempOptions = [...item.options];
            const optionIndex = item.options.findIndex((option) => option.id === (data === null || data === void 0 ? void 0 : data.id));
            if (optionIndex > -1) {
                tempOptions[optionIndex] = Object.assign(Object.assign({}, tempOptions[optionIndex]), { price: value });
                onItemPriceChange &&
                    onItemPriceChange(Object.assign(Object.assign({}, ((_a = deal === null || deal === void 0 ? void 0 : deal.items.find((i) => i.id === item.id)) !== null && _a !== void 0 ? _a : item)), { options: tempOptions }));
            }
        }
    };
    /**
     * @function onItemPriceOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onPriceOnBlur = () => {
        onPriceChange(Number(pricePerUnit));
    };
    /**
     * @function onMarkupClick
     * @since 1.0.0
     * @hidden
     */
    const onMarkupClick = () => {
        var _a;
        setUserInputMarkup(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = markupRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onMarginClick
     * @since 1.0.0
     * @hidden
     */
    const onMarginClick = () => {
        var _a;
        setUserInputMargin(true);
        setUserInputMarkup(false);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = marginRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onDiscountClick
     * @since 1.0.0
     * @hidden
     */
    const onDiscountClick = () => {
        var _a;
        setUserInputMarkup(false);
        setUserInputMargin(false);
        setUserInputDiscount(true);
        setUserInputPricePerUnit(false);
        (_a = discountRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onPricePerUnitClick
     * @since 1.0.0
     * @hidden
     */
    const onPricePerUnitClick = () => {
        var _a;
        setUserInputPricePerUnit(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputMarkup(false);
        (_a = pricePerUnitRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onManageOption
     * @since 1.0.0
     * @hidden
     */
    function onManageOption(value) {
        switch (value) {
            case 'include':
                onPressAddOptionToItem();
                break;
            case 'hide':
                hideDealItemConfiguration(item, data, 'option');
                break;
            case 'delete':
                onPressDeleteProposedOption();
                break;
            case 'moveUp':
                onMoveItemConfiguration(item, data, 'option', 'up');
                break;
            case 'moveDown':
                onMoveItemConfiguration(item, data, 'option', 'down');
                break;
            case 'checkAvailability':
                setOpenModalAvailability(true);
                break;
        }
    }
    /**
     * @function onEditPress
     * @since 1.0.0
     * @hidden
     */
    function onEditPress() {
        setOpenModalEditFields(true);
    }
    /**
     * @function onSaleItemDetail
     * @since 1.0.0
     * @hidden
     */
    function onSaleItemDetail() {
        var _a;
        if (data === null || data === void 0 ? void 0 : data.item) {
            modal.present({
                title: hideSKU === 'FALSE' ? (_a = data === null || data === void 0 ? void 0 : data.item) === null || _a === void 0 ? void 0 : _a.sku : undefined,
                picto: '',
                className: 'deal-sale-item-selector-item-modal',
                modal: React.createElement(SaleItemViewer, { item: data.item })
            });
        }
    }
    /**
     * @function openFile
     * @since 1.0.0
     * @hidden
     */
    function openFile(file) {
        modal.present({
            title: file.file.filename,
            picto: '',
            className: 'deal-sale-item-selector-item-modal',
            modal: (React.createElement("div", { className: "deal-sale-item-selector-item-modal-file" },
                React.createElement("embed", { src: file.file.url, width: "100%", height: "100%" })))
        });
    }
    const dropdown = [];
    const visibilityDropdown = [];
    dropdown.push({
        value: 'include',
        picto: 'plus',
        label: t('Include')
    });
    if (user.can('calendar.availability.check')) {
        dropdown.push({
            value: 'checkAvailability',
            picto: 'calendar-check',
            label: t('Check availability')
        });
    }
    if (data.hide) {
        visibilityDropdown.push({
            value: 'hide',
            picto: 'eye',
            label: t('Show line')
        });
    }
    else {
        visibilityDropdown.push({
            value: 'hide',
            picto: 'eye-slash',
            label: t('Hide line')
        });
    }
    visibilityDropdown.push({
        value: 'moveUp',
        picto: 'arrow-up',
        label: t('Move up')
    });
    visibilityDropdown.push({
        value: 'moveDown',
        picto: 'arrow-down',
        label: t('Move down')
    });
    visibilityDropdown.push({
        value: 'delete',
        picto: 'times',
        label: t('Remove')
    });
    let itemTitle = (_k = data.item) === null || _k === void 0 ? void 0 : _k.title;
    if (((_l = data.item) === null || _l === void 0 ? void 0 : _l.title) && ((_m = data.item) === null || _m === void 0 ? void 0 : _m.title.length) > 60) {
        itemTitle = (_o = data.item) === null || _o === void 0 ? void 0 : _o.title.slice(0, 60).concat('...');
    }
    const quoteLanguage = (_p = (deal !== null && deal !== void 0 ? deal : quoteContext.deal)) === null || _p === void 0 ? void 0 : _p.language;
    const publicFiles = (_s = (_r = (_q = data.item) === null || _q === void 0 ? void 0 : _q.files) === null || _r === void 0 ? void 0 : _r.filter((file) => file.visibility === 'PUBLIC')) !== null && _s !== void 0 ? _s : [];
    const languageFiles = publicFiles.filter((file) => !file.language || !quoteLanguage || file.language.code === quoteLanguage);
    const filteredFiles = languageFiles.length > 0 ? languageFiles : publicFiles;
    // Check if item have infos or image
    const hasInfos = !!((_t = data.item) === null || _t === void 0 ? void 0 : _t.infos);
    const hasSummary = !!((_u = data.item) === null || _u === void 0 ? void 0 : _u.summary) && !!striptags(data.item.summary).trim();
    const hasImage = !!((_v = data.item) === null || _v === void 0 ? void 0 : _v.image) && !!data.item.image.image.url;
    const isClickable = hasInfos || hasImage || hasSummary;
    useEffect(() => {
        setPricePerUnit(Number.isFinite(amount) ? amount.toFixed(2).toString() : '0');
    }, [amount]);
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChange = (value) => {
        setQuantity(Number(value));
    };
    /**
     * @function onQuantityChangeOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChangeOnBlur = () => {
        if (quantity !== data.quantity) {
            const onQuantityChangeHandler = deal
                ? onOptionQuantityChange
                : quoteContext.onOptionQuantityChange;
            onQuantityChangeHandler(item, data, quantity);
        }
    };
    /**
     * @function onCloseModal
     * @since 1.0.0
     * @hidden
     */
    const onCloseModal = () => {
        if (openModalEditFields) {
            setOpenModalEditFields(false);
        }
    };
    const className = classNames('deal-item-panel-group-content', 'deal-item-panel-group-content-proposed-options-row', { 'deal-item-panel-group-content--isClickable': isClickable && !editable }, { 'deal-item-panel-group-content--hide': data.hide }, props.className);
    return editable || (!editable && breakpoint.isAboveOrEqual('md')) ? (React.createElement(React.Fragment, null,
        React.createElement("tr", { className: className, onClick: isClickable && !editable ? onSaleItemDetail : undefined },
            React.createElement("td", { className: "deal-item-panel-group-content-cell--primary", "data-label": t('Option') },
                React.createElement("div", { className: "deal-item-panel-group-content-cell--primary--title" },
                    !((_w = data.item) === null || _w === void 0 ? void 0 : _w.active) || data.item.deletedAt ? (React.createElement(Icon, { value: "exclamation-triangle", style: "danger", tooltip: t('This item is no longer available.') })) : hasImage ? (React.createElement(Image, { className: "table-row-image", source: (_z = (_y = (_x = data.item) === null || _x === void 0 ? void 0 : _x.image) === null || _y === void 0 ? void 0 : _y.image.url) !== null && _z !== void 0 ? _z : '', onClick: editable ? onSaleItemDetail : undefined })) : hasInfos || hasSummary ? (React.createElement(Button, { style: "picto", picto: "circle-info", onPress: editable ? onSaleItemDetail : undefined })) : (React.createElement(Button, { style: "picto", picto: "", disabled: true })),
                    data.alternativeTo && (React.createElement("div", { className: "deal-item-panel-group-content-title-tooltip" },
                        React.createElement(Icon, { className: "deal-item-panel-group-content-title-tooltip-picto", value: "right-left" }),
                        React.createElement(Text, { className: "deal-item-panel-group-content-title-tooltip-value", value: t('Alternative to') +
                                ' ' +
                                ((_2 = (_1 = (_0 = item.options) === null || _0 === void 0 ? void 0 : _0.find((option) => { var _a; return ((_a = option.item) === null || _a === void 0 ? void 0 : _a.id) === data.alternativeTo; })) === null || _1 === void 0 ? void 0 : _1.item) === null || _2 === void 0 ? void 0 : _2.title) }))),
                    React.createElement(Text, { className: "deal-item-panel-group-content-value", value: itemTitle, onClick: editable ? onSaleItemDetail : undefined }),
                    filteredFiles && (filteredFiles === null || filteredFiles === void 0 ? void 0 : filteredFiles.length) > 0 && (React.createElement("div", { className: "deal-item-panel-group-content-cell--files", onClick: (e) => e.stopPropagation() }, filteredFiles.map((file) => (React.createElement(Icon, { value: "paperclip", onClick: () => openFile(file), key: file.id }))))))),
            hideSKU === 'FALSE' && (React.createElement("td", { "data-label": t('Sku'), className: "td-sku" },
                React.createElement(Text, { className: "deal-item-panel-group-content-value deal-item-panel-group-content-value--sku", value: (_3 = data.item) === null || _3 === void 0 ? void 0 : _3.sku }))),
            (!itemsGrouped || editable) && (React.createElement("td", { "data-label": t('Group') },
                React.createElement(Text, { className: classNames({ 'deal-item-panel-group-content-value': true }, {
                        'deal-item-panel-group-content-value--group': (_4 = data.item) === null || _4 === void 0 ? void 0 : _4.group
                    }), value: (_6 = (_5 = data.item) === null || _5 === void 0 ? void 0 : _5.group) === null || _6 === void 0 ? void 0 : _6.title }))),
            hasDealItemConfigurationTime && (React.createElement("td", { className: "field-cell", "data-label": t('Time') }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, data.startTime || data.endTime ? (React.createElement("span", { className: "deal-item-panel-group-content-value" },
                data.startTime && (React.createElement(DateTime, { date: false, time: true, value: data.startTime, hh: "2-digit", mm: "2-digit" })),
                data.startTime && data.endTime && ' — ',
                data.endTime && (React.createElement(DateTime, { date: false, time: true, value: data.endTime, hh: "2-digit", mm: "2-digit" })))) : (React.createElement(Button, { style: "picto", picto: "clock" })))) : data.startTime || data.endTime ? (React.createElement("span", { className: "deal-item-panel-group-content-value" },
                data.startTime && (React.createElement(DateTime, { date: false, time: true, value: data.startTime, hh: "2-digit", mm: "2-digit" })),
                data.startTime && data.endTime && ' — ',
                data.endTime && (React.createElement(DateTime, { date: false, time: true, value: data.endTime, hh: "2-digit", mm: "2-digit" })))) : null)),
            quoteDealItemConfigurationFields.length > 0 &&
                (quoteDealItemConfigurationFields === null || quoteDealItemConfigurationFields === void 0 ? void 0 : quoteDealItemConfigurationFields.map((field) => {
                    var _a, _b;
                    const v = (_b = (_a = data.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => { var _a; return ((_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id) === field.id; })) === null || _b === void 0 ? void 0 : _b.value;
                    return (React.createElement("td", { key: field.id, className: "field-cell" }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, v ? (field.type === 'FILE' ? (React.createElement(Icon, { value: "file" })) : (React.createElement(React.Fragment, null,
                        React.createElement(Text, { className: "deal-item-panel-group-content-value", value: formatFieldValue(v, field.type, field, i18n.language) }),
                        React.createElement(Icon, { value: "pencil" })))) : (React.createElement(Button, { picto: field.type === 'DATE'
                            ? 'calendar'
                            : field.type === 'TIME'
                                ? 'clock'
                                : 'plus', style: "picto" })))) : field.type === 'FILE' ? (React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(v, field.type, field), noLabel: true })) : (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: v
                            ? formatFieldValue(v, field.type, field, i18n.language)
                            : '' }))));
                })),
            (quantityTypeValue === 'GRANULAR' ||
                quantityTypeValue === 'ITEM_CONFIGURATION') && (React.createElement("td", { "data-label": t('Quantity'), className: "deal-item-panel-group-content-value--qty" }, editable ? (React.createElement(FormInput, { className: "deal-item-panel-group-content-input input-quantity", type: "number", name: "quantity", value: quantity.toString(), onChange: (value) => onQuantityChange(value), onBlur: onQuantityChangeOnBlur, min: "0", size: "small", suffix: quantitySuffix })) : showConfigurationQuantity ? (React.createElement("div", { className: "deal-item-panel-group-content-value--uneditable-qty" },
                React.createElement(Text, { className: "deal-item-panel-group-content-value", value: quantity.toString() }),
                React.createElement(Case, { is: !!quantitySuffix },
                    React.createElement(Text, { className: "deal-item-panel-group-content-value--unitOfMeasurement", value: quantitySuffix })))) : null)),
            React.createElement(Case, { is: editable },
                React.createElement("td", { "data-label": t('Price'), className: "deal-item-panel-group-content-price" },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: costPrice }))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer discount'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerDiscount })))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer price'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerPrice })))),
            editable && pricingParameters === 'DISCOUNT' && (React.createElement("td", { "data-label": t('Discount') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onDiscountClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputDiscount ? onDiscountChange : undefined, value: discount.toString(), disabled: userInputDiscount ? false : true, className: userInputDiscount ? 'number-input isActive' : 'number-input', ref: discountRef, size: "small" }),
                React.createElement(Icon, { value: userInputDiscount ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARKUP' &&
                pricingParametersDisplay == 'line' && (React.createElement("td", { "data-label": t('Markup') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon-content", onClick: onMarkupClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMarkup ? onMarkupChange : undefined, value: markup, disabled: userInputMarkup ? false : true, className: userInputMarkup ? 'number-input isActive' : 'number-input', ref: markupRef, size: "small" }),
                React.createElement(Icon, { value: userInputMarkup ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARGIN' &&
                pricingParametersDisplay == 'line' && (React.createElement("td", { "data-label": t('Margin') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon-content", onClick: onMarginClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMargin ? onMarginChange : undefined, value: margin, disabled: userInputMargin ? false : true, className: userInputMargin ? 'number-input isActive' : 'number-input', ref: marginRef, size: "small" }),
                React.createElement(Icon, { value: userInputMargin ? 'angle-left' : 'angle-right' }))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Selling price') + ' ($', className: "deal-item-panel-group-content-input input-profit deal-item-panel-group-content-price", onClick: onPricePerUnitClick }, editable ? (React.createElement(FormInput, { type: "number", suffix: "$", onChange: userInputPricePerUnit
                    ? onOptionProposedPricePerUnitChange
                    : undefined, onBlur: onPriceOnBlur, value: pricePerUnit, disabled: userInputPricePerUnit ? false : true, className: userInputPricePerUnit
                    ? 'number-input isActive'
                    : 'number-input', ref: pricePerUnitRef, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        onPriceOnBlur();
                    }
                }, size: "small" })) : (React.createElement(DealItemDiscountedPrice, { className: "deal-item-panel-group-content-value", value: Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount })))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Total'), className: "deal-item-panel-group-content-price" },
                React.createElement(Money, { className: "deal-item-panel-group-content-value", value: Number(pricePerUnit) * effectiveQuantity }))),
            isDeal && (React.createElement("td", { "data-label": t('Actions') },
                React.createElement("div", { className: "cell-button-actions" },
                    React.createElement(Case, { is: editable },
                        React.createElement(ButtonDropdown, { picto: "eye", options: visibilityDropdown, onSelect: onManageOption, className: "first" }),
                        React.createElement(ButtonDropdown, { options: dropdown, onSelect: onManageOption, className: "last" }))))),
            !isDeal && (React.createElement("td", { "data-label": t('Actions') },
                React.createElement("div", { onClick: (e) => e.stopPropagation() },
                    React.createElement(Button, { style: "picto", picto: data.alternativeTo ? 'right-left' : 'plus', className: 'deal-item-panel-group-content-add-proposed-button' +
                            (data.alternativeTo
                                ? ' deal-item-panel-group-content-add-proposed-button--alternative'
                                : ''), onPress: onPressAddOption }))))),
        openModalAvailability && dealValue && (React.createElement(DealAvailabilityModal, { deal: dealValue, onClose: () => setOpenModalAvailability(false), saleItemId: (_7 = data.item) === null || _7 === void 0 ? void 0 : _7.id, saleItemTitle: (_8 = data.item) === null || _8 === void 0 ? void 0 : _8.title, isOption: true })),
        openModalEditFields && (React.createElement(DealItemEditModal, { type: "option", item: data, customFields: quoteDealItemConfigurationFields, hasTime: hasDealItemConfigurationTime, timeSlotCheck: deal
                ? {
                    dealId: deal.id,
                    date: getTimeSlotDate(item.date, deal.plannedDateStart)
                }
                : undefined, onClose: onCloseModal, onUpdateItem: (updatedItem, applyToAll) => {
                var _a, _b, _c;
                const cfg = updatedItem;
                updateOptionFieldValues(item.id, updatedItem.id, (_a = updatedItem.fieldValues) !== null && _a !== void 0 ? _a : [], applyToAll, hasDealItemConfigurationTime
                    ? ((_b = cfg.startTime) !== null && _b !== void 0 ? _b : null)
                    : undefined, hasDealItemConfigurationTime ? ((_c = cfg.endTime) !== null && _c !== void 0 ? _c : null) : undefined);
                setOpenModalEditFields(false);
            } })))) : (React.createElement("div", { className: "deal-item-panel-group__content--mobile" },
        React.createElement("div", { className: "deal-item-panel-group__content--mobile-row" },
            React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-picto" }, !item.item.active || item.item.deletedAt ? (React.createElement(Icon, { value: "exclamation-triangle", style: "danger", tooltip: t('This item is no longer available.') })) : hasImage ? (React.createElement(Image, { className: "table-row-image", source: (_11 = (_10 = (_9 = item.item) === null || _9 === void 0 ? void 0 : _9.image) === null || _10 === void 0 ? void 0 : _10.image.url) !== null && _11 !== void 0 ? _11 : '', onClick: onSaleItemDetail })) : hasInfos || hasSummary ? (React.createElement(Button, { style: "picto", picto: "circle-info", onPress: onSaleItemDetail })) : (React.createElement(Button, { style: "picto", picto: "", disabled: true }))),
            React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-value" },
                React.createElement(Text, { value: itemTitle, onClick: editable ? onSaleItemDetail : undefined })),
            pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ? (React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-value" },
                data.priceDisplay === 'INCLUDED' && React.createElement(Text, { value: t('Included') }),
                data.priceDisplay === 'AMOUNT' && (React.createElement(Money, { value: Number(pricePerUnit) * effectiveQuantity })))) : null),
        React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow" },
            hideSKU === 'FALSE' && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('SKU')),
                React.createElement(Text, { className: "deal-item-panel-group__content--mobile-subrow--value", value: (_12 = data.item) === null || _12 === void 0 ? void 0 : _12.sku }))),
            React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Category')),
                React.createElement(Text, { value: (_14 = (_13 = data.item) === null || _13 === void 0 ? void 0 : _13.group) === null || _14 === void 0 ? void 0 : _14.title })),
            (quantityTypeValue === 'GRANULAR' ||
                quantityTypeValue === 'ITEM_CONFIGURATION') &&
                showConfigurationQuantity && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Quantity')),
                React.createElement(Text, { value: quantity.toString() }))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE') && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Price')),
                data.priceDisplay === 'INCLUDED' ? (React.createElement(Text, { value: t('Included') })) : data.priceDisplay === 'AMOUNT' ? (React.createElement(DealItemDiscountedPrice, { value: Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount })) : null)),
            quoteDealItemConfigurationFields.length > 0
                ? quoteDealItemConfigurationFields === null || quoteDealItemConfigurationFields === void 0 ? void 0 : quoteDealItemConfigurationFields.map((field) => {
                    var _a, _b;
                    const v = (_b = (_a = data.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => { var _a; return ((_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id) === field.id; })) === null || _b === void 0 ? void 0 : _b.value;
                    return (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value", key: field.id },
                        React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, field.title),
                        field.type === 'FILE' ? (React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(v, field.type, field), noLabel: true })) : (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: v
                                ? formatFieldValue(v, field.type, field, i18n.language)
                                : '' }))));
                })
                : null,
            filteredFiles && (filteredFiles === null || filteredFiles === void 0 ? void 0 : filteredFiles.length) > 0 && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value deal-item-panel-group-content-cell--files", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Files')),
                filteredFiles.map((file) => (React.createElement(Icon, { value: "paperclip", onClick: () => openFile(file), key: file.id }))))),
            React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Actions')),
                React.createElement(Button, { style: "picto", picto: data.alternativeTo ? 'right-left' : 'plus', className: 'deal-item-panel-group-content-add-proposed-button' +
                        (data.alternativeTo
                            ? ' deal-item-panel-group-content-add-proposed-button--alternative'
                            : ''), onPress: onPressAddOption })))));
}
